import React from "react";
import { Button, Modal } from 'react-bootstrap';
import styles from '../../../../styles/FarmGlobal/TesteDeBase.module.scss';
import { useFGTesteDeBase } from "../../../../contexts/FarmGlobal/TesteDeBaseContext.js";

const ModalConfirmacao = () => {

    const { showConfirmacao, handleSave, setShowConfirmacao, materialSelecionado } = useFGTesteDeBase();

    return (
        <Modal
            show={showConfirmacao}
            onHide={()=> { setShowConfirmacao(false);}}
            backdrop="static"
            keyboard={false}
            centered
        >
        <Modal.Header>
            <Modal.Title>Confirmação de Solicitação</Modal.Title>
        </Modal.Header>
        <Modal.Body  style={{textAlign:'center'}}>
            <span>              
                Tem certeza que deseja seguir com a solicitação de teste para a base  <br/><strong>{materialSelecionado?.Descricao}</strong>?                
            </span>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
            <Button
                    variant="success"
                    className={styles.modalBtn}
                    onClick={handleSave}
                >
                    Sim
                </Button>
                <Button
                    variant="outline-danger"
                    className={styles.modalBtn}
                    onClick={()=> { setShowConfirmacao(false);}}
                >
                    Voltar
                </Button>
        </Modal.Footer>
      </Modal>
    ) 
}

export default ModalConfirmacao;
